var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPolicies = function SvgPolicies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.987948 2.63364C2.72754 2.20371 4.88057 0.863855 5.90473 0.18015C6.26453 -0.0600494 6.73547 -0.0600502 7.09528 0.180149C8.11943 0.863852 10.2725 2.2037 12.0121 2.63364C12.5482 2.76614 13 3.21592 13 3.76821V7.26988C13 12.0692 8.05077 14.2034 6.78964 14.6694C6.60158 14.7389 6.39842 14.7389 6.21036 14.6694C4.94923 14.2034 0 12.0691 0 7.26988V3.76821C0 3.21592 0.451795 2.76615 0.987948 2.63364ZM10.2329 6.18039C10.6086 5.77564 10.5851 5.14292 10.1804 4.76715C9.77564 4.39138 9.14292 4.41487 8.76715 4.81961L5.93149 7.87392L4.66271 6.75112C4.24912 6.38512 3.61713 6.4237 3.25112 6.83729C2.88512 7.25088 2.9237 7.88287 3.33729 8.24888L5.33729 10.0188C5.74392 10.3786 6.36341 10.3482 6.73285 9.95027L10.2329 6.18039Z",
    fill: "current"
  })));
};
export default SvgPolicies;